/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { box } from '@/utils/dev.js';
import Actionsheet from "vux/src/components/actionsheet/index.vue";
export default {
  name: 'ExtraBtn',
  components: {
    Actionsheet: Actionsheet
  },
  data: function data() {
    return {
      showMenu: false,
      box: box
    };
  },
  computed: {
    inDevelopment: function inDevelopment() {
      return process.env.NODE_ENV === 'development' && this.box.show && this.box.items.length;
    }
  },
  methods: {
    menuClick: function menuClick(v) {
      this.$DingTalk.self.onSuccess({
        id: v
      });
    }
  }
};